export const colors = {
  orange: '#E57200',
  lighterBlue: '#eefaff',
  blue: '#326295',
  darkBlue: '#061d33',
  lightGray: '#F1F1F2',
  mediumGray: '#D9D9D9',
  darkGray: '#63666A',
  linkColor: '#0000A3',
  priority1: '#f76e6e',
  priority2: '#e49a50',
  priority3: '#f3df96',
  priority5: '#b9d9eb',
  white: '#fff',
  lightWhite: 'rgba(255, 255, 255, 0.15)',
  green: '#b7eb8f',
};

export const FloatRight = { float: 'right' };

export const FloatLeft = { float: 'left' };

export const BoldFont = { fontWeight: 'bold' };

export const ItalicFont = { fontStyle: 'italic' };

export const UnderlineFont = { textDecorationLine: 'underline' };

export const FullWidth = { width: '100%' };

export const NoBottomMargin = { marginBottom: '0' };

export const WithBottomMargin = { marginBottom: '0.2em' };

export const WithBottomMargin4 = { marginBottom: '0.4em' };

export const WithBottomMargin8 = { marginBottom: '0.8em' };

export const WithBottomMargin16 = { marginBottom: '1.6em' };

export const WithTopMargin = { marginTop: '0.2em' };

export const WithTopMargin4 = { marginTop: '0.4em' };

export const WithTopMargin8 = { marginTop: '0.8em' };

export const WithTopPadding4 = { paddingTop: '0.4em' };

export const WithBottomPadding8 = { paddingBottom: '0.8em' };

export const WithLeftMargin2 = { marginLeft: '0.2em' };

export const WithLeftMargin10 = { marginLeft: '1em' };

export const AlightTextToRight = { textAlign: 'right' };
